import { render, staticRenderFns } from "./EditAgreementDetails.vue?vue&type=template&id=07f53254&scoped=true&"
import script from "./EditAgreementDetails.vue?vue&type=script&lang=js&"
export * from "./EditAgreementDetails.vue?vue&type=script&lang=js&"
import style0 from "./EditAgreementDetails.vue?vue&type=style&index=0&id=07f53254&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f53254",
  null
  
)

export default component.exports